import * as React from 'react';
import { values } from 'lodash';
import { bindActionCreators } from 'redux';
import { Dispatch, connect } from 'react-redux';
import { LoadingIndicator } from '@digital/react-aviva-atom';

import { Products } from '../../components/products/Products';
import { setProgressStep } from '../../redux/progress-bar/progressBar';
import { RootState } from '../../app/store';

import './ShowProducts.css';

interface InjectedState {
    availableProducts: endpoints.ProductDTO[];
    productsLoading: boolean;
}

interface DispatchProps {
    setProgressStep: (payload: { step: number }) => void;
}

type OwnProps = {};

export type Props = DispatchProps & InjectedState & OwnProps;

export class ShowProducts extends React.PureComponent<Props> {

    componentDidMount() {
        this.props.setProgressStep({ step: 1 });
        let appEventData = 'AppEventData';
        window[appEventData].push({
            event: 'stepLoaded',
            page: {
                'pageName': 'ie:secure:my-aviva:driving-school:product',
                'channel': 'secure'
              }
        });
    }

    renderProducts = () => {
        const { availableProducts, productsLoading } = this.props;
        if (productsLoading) {
            return (
                <div className="a-loading-indicator-container centre" data-testid="loading-indicator">
                    <LoadingIndicator size="large">Loading...</LoadingIndicator>
                </div>
            );
        } else {
            return (
                <Products products={availableProducts} />
            );
        }
    }

    render() {
        return (
            <div className="show-products-container" data-testid="show-products">
                {this.renderProducts()}
            </div>
        );
    }
}

export function mapStateToProps(state: RootState) {
    return {
        availableProducts: values(state.products.availableProducts),
        productsLoading: state.products.loading
    };
}

const mapDispatchToProps = (dispatch: Dispatch<RootState>) => {
    return bindActionCreators(
        {
            setProgressStep,
        },
        dispatch
    );
};

export default connect<InjectedState, DispatchProps, OwnProps, RootState>(mapStateToProps, mapDispatchToProps)(ShowProducts);
